import React from "react";
import { Col, Row, Tag } from "antd";
import Widget from "components/Widget/index";
import { Fragment } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import _ from "lodash";
import moment from "moment";
import "./newsCard.css";

const NewsCard = ({ news }) => {
  return (
    <Widget styleName="gx-p-lg-1" style={{ position: "relative" }}>
      <Row>
        <Col xl={7} lg={10} md={10} sm={10} xs={24}>
          <Link
            to={`/news/${news.id}-${
              news.title ? news.title.replace(/\s+/g, "-").toLowerCase() : ""
            }`}
          >
            <img
              className="gx-rounded-lg gx-w-100"
              alt="..."
              src={
                news.image ? news.image : "/app/assets/images/logo_w_text.png"
              }
            />
          </Link>
        </Col>
        <Col xl={15} lg={14} md={14} sm={14} xs={24}>
          <div className="gx-fnd-content">
            <Link
              to={`/news/${news.id}-${
                news.title ? news.title.replace(/\s+/g, "-").toLowerCase() : ""
              }`}
            >
              {" "}
              <h3 className="gx-text-uppercase gx-text-black gx-font-weight-bold ">
                {news.title}
              </h3>{" "}
            </Link>

            <p>{news.shortContent}</p>

            <div
              style={{ borderBottom: "1px solid #ccc", margin: "10px 0" }}
            ></div>
            <p className="gx-text-grey">
              {`Written ${moment(news?.creationDate).fromNow()}`} by{" "}
              {news?.user?.name === "Ella Trusteddocks" ? (
                <a
                  href="https://ella.trusteddocks.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {news.user.name}
                </a>
              ) : (
                news?.user?.name
              )}
            </p>
            <p
              className="gx-text-grey tag-container"
              style={{ flexWrap: "wrap" }}
            >
              {news.tagNames?.map((c, idx) => {
                return (
                  <Fragment key={`item_${idx}`}>
                    <Link
                      className="news-tag-container"
                      to={`guide/construction/?tagGroupId=${c.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Tag
                        className="news-tag-type"
                        color="blue"
                        style={{
                          marginTop: 0,
                          marginBottom: 0,
                        }}
                      >
                        {c.name}
                      </Tag>
                    </Link>
                  </Fragment>
                );
              })}
            </p>
            <p className="gx-text-grey" style={{ flexWrap: "wrap" }}>
              {news.tagsArray?.map((t, idx) => {
                const formattedTag = t
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase());

                return (
                  <Tag
                    className="news-tag"
                    key={`tag_${idx}`}
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                    }}
                  >
                    {formattedTag}
                  </Tag>
                );
              })}
            </p>
            <p
              className="gx-text-grey tag-container"
              style={{ flexWrap: "wrap" }}
            >
              {news.relatedItems?.map((c, idx) => {
                return (
                  <Fragment key={`item_${idx}`}>
                    {c.type === "shipyard" && (
                      <Link
                        className="news-tag-container"
                        to={c.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Tag
                          className="news-tag"
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                        >
                          {c.name}
                        </Tag>
                      </Link>
                    )}
                  </Fragment>
                );
              })}
            </p>
          </div>{" "}
        </Col>
      </Row>
    </Widget>
  );
};

export default NewsCard;
